import _ from 'lodash';
import { apiSearch, apiFetch } from '../utility';

const TANK_ESTIMATES = 'logistics/delivery/TANK_ESTIMATES';
const CARRIER_EMAIL = 'logistics/delivery/CARRIER_EMAIL';

const initialState = {
	estimatesByStationTank : {},
	emailsByStationDeliveryId : {},
};

export default (state = initialState, action) => {

	let estimatesByStationTank;
	let emailsByStationDeliveryId;
	switch (action.type) {

		case TANK_ESTIMATES:
			estimatesByStationTank = _.assign({}, state.estimatesByStationTank);
			_.forEach(action.estimates, estimate => {
				const stationTank = `${estimate.stationId}_${estimate.tankNumber}`;
				estimatesByStationTank[stationTank] = estimate;
			});

			return {
				...state,
				estimatesByStationTank,
			};

		case CARRIER_EMAIL:

			emailsByStationDeliveryId = _.assign({}, state.emailsByStationDeliveryId);
			_.forEach(action.jobResults, jobResult => {
				emailsByStationDeliveryId[jobResult.stationDeliveryId] = jobResult;
			});

			return {
				...state,
				emailsByStationDeliveryId,
			};

		default:
			return state;
	}
};

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			base : 'stationDelivery',
			dispatch,
			callback,
		});
	};
};

export const getStationDeliveriesForStation = ({stationId, afterDateTime, callback = _.noop}) => {
	return dispatch => {

		const params = {
			stationIds : [stationId],
		};

		if (afterDateTime) {
			params.afterDateTime = afterDateTime;
		}

		apiSearch({
			method : 'stationDelivery.search',
			listName : 'stationDeliveriesForStation',
			idName : 'stationDeliveryIds',
			keyBy : stationId,
			params,
			dispatch,
			callback,
		});
	};
};


export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const publicGet = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.public.get',
			params,
			dispatch,
			callback,
		});
	};
};

export const estimate = ({params = {}, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.estimate',
			params,
			dispatch,
			callback : function (err, r) {
				if (!err) {
					dispatch({
						type: TANK_ESTIMATES,
						estimates: r
					});
				}
				callback(err, r);
			}
		});
	};
};

export const activate = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.activate',
			params,
			dispatch,
			successMessage : `Delivery scheduled successfully. Carrier emails have been sent.`,
			onSuccessRedirectTo : '/logistics/deliveries',
			callback
		});
	};
};

export const cancel = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.cancel',
			params,
			dispatch,
			successMessage : `Delivery canceled successfully. Carrier emails have been sent.`,
			onSuccessRedirectTo : '/logistics/deliveries',
			callback
		});
	};
};


export const verify = ({stationDeliveryId, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.verify',
			params : { stationDeliveryId },
			dispatch,
			successMessage : `Delivery verified successfully.`,
			//onSuccessRedirectTo : '/logistics/deliveries',
			callback
		});
	};
};

export const confirm = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.public.confirm',
			params,
			successMessage : `Delivery confirmation successful. Thank you!`,
			dispatch,
			callback
		});
	};
};

export const getCarrierEmail = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.getCarrierEmail',
			params,
			dispatch,
			callback : function (err, r) {
				if (!err) {
					dispatch({
						type: CARRIER_EMAIL,
						jobResults: r.jobResults,
					});
				}
				callback(err, r);
			}
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.add',
			listNameToUpdate : 'stationDeliveryIds',
			params,
			dispatch,
			//successMessage : `Delivery scheduled successfully.`,
			//onSuccessRedirectTo : '/logistics/deliveries',
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: 'stationDelivery.update',
			params,
			dispatch,
			//successMessage : `E85 Delivery updated successfully.`,
			//onSuccessRedirectTo : '/logistics/deliveries',
			callback,
		});
	};
};

export const searchLogs = ({stationDeliveryId, callback = _.noop}) => {
	return dispatch => {
		apiSearch({
			method : 'stationDelivery.log.search',
			base : 'stationDeliveryLog',
			keyBy : stationDeliveryId,
			params : {
				stationDeliveryId,
			},
			dispatch,
			callback,
		});
	};
};

